import { reportClient } from '../../api/clients';
import fetchSbomLibrariesFilters from './get-libraries-filters/get-libraries-filters';
import getSbomLibraries from './get-libraries/get-libraries-service';

const sbomService = {
  getSbomLibraries: getSbomLibraries(reportClient),
  getSbomLibrariesFilters: fetchSbomLibrariesFilters(reportClient),
};

export default sbomService;
